import { component } from 'flightjs';

function ShowAllFiltersUI() {
    this.defaultAttrs({
        showAllButton: '[data-tag-navigation-filter-show-all]',
        showAllButtonTypeData: 'tag-navigation-filter-show-all',
        showAllButtonPlaceholderData: 'tag-modal-search-placeholder'
    });

    this._triggerModal = function(evt, payload) {
        let $payloadEl = $(payload.el);
        let modalType = $payloadEl.data(this.attr.showAllButtonTypeData);
        let placeholder = $payloadEl.data(
            this.attr.showAllButtonPlaceholderData
        );
        let options = {
            cssClass: 'modal-tags',
            placeholder: placeholder,
            parentNode: this.$node,
            modalType: modalType
        };

        this.trigger(document, 'ui:search-result:on-open-filters', options);
    };

    this.after('initialize', function() {
        this.on('click', {
            showAllButton: this._triggerModal
        });
    });
}

export default component(ShowAllFiltersUI);
